import { ChangeDetectionStrategy, Component, Input, Inject } from '@angular/core';
import { AgrI18nSharedModule } from '@next/core-lib/i18n';
import { SelectedLocation } from '@next/core-lib/user';

import { TermsAndConditionsAssetsService } from 'src/app/services/terms-and-conditions-assets.service';

@Component({
  selector: 'app-cart-agreement',
  templateUrl: './agreement.component.html',
  styleUrls: ['./agreement.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AgrI18nSharedModule],
})
export class AgreementComponent {
  @Input() location: SelectedLocation;

  constructor(@Inject(TermsAndConditionsAssetsService) private readonly termsAndConditionsService: TermsAndConditionsAssetsService) {}

  redirectToTermsAndConditions(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    const salesArea = this.location?.salesAreas[0]?.salesOrganization;

    if (!salesArea) {
      return;
    }

    const url = this.termsAndConditionsService.getGeneralTermsAndConditions(salesArea).url;
    window.open(url);
  }
}
